module.exports = __webpack_public_path__ + "img/CF.2094d488.svg";